import {
  isBooleanTableFilter,
  isDateTimeTableFilter,
  isSelectTableFilter,
} from '@ipfabric/utils';
import type { FC } from 'react';
import { SimpleDateTimeFilter } from './SimpleDateTimeFilter';
import { SimpleSelectFilter } from './SimpleSelectFilter';
import { SimpleTextFilter } from './SimpleTextFilter';
import type { ChangeFilterEvent } from './types/ChangeFilterEvent';
import type { SimpleFilterField } from './types/SimpleFilterField';

interface Props {
  filterField: SimpleFilterField;
  onChangeFilter: (command: ChangeFilterEvent) => void;
  onSubmitFilters: () => void;
  autoFocus?: boolean;
}

export const SimpleFilterInput: FC<Props> = (props) => {
  if (
    isSelectTableFilter(props.filterField.filter) ||
    isBooleanTableFilter(props.filterField.filter)
  ) {
    return (
      <SimpleSelectFilter
        {...props}
        // passing options as standalone prop to ensure proper typing
        options={props.filterField.filter.options}
        autoFocus={props.autoFocus}
      />
    );
  }
  if (isDateTimeTableFilter(props.filterField.filter)) {
    return <SimpleDateTimeFilter {...props} autoFocus={props.autoFocus} />;
  }
  return <SimpleTextFilter {...props} autoFocus={props.autoFocus} />;
};
